/*
  Strings for the operator error reports page (/admin/errors). Keys the app
  already translates are left to their existing wording.
  Merged into TRANSLATION_MAPS in ./index.js.
*/

const ru = {
  "Error reports": "Отчёты об ошибках",
  "Server and browser errors grouped by cause. Resolve hides a report until the error happens again; Ignore keeps it quiet.": "Ошибки сервера и браузера, сгруппированные по причине. «Решено» скрывает отчёт, пока ошибка не повторится; «Игнорировать» отключает его.",
  "Unresolved": "Нерешённые",
  "Ignored": "Игнорируемые",
  "All": "Все",
  "All sources": "Все источники",
  "Server": "Сервер",
  "Search by error text": "Поиск по тексту ошибки",
  "Count": "Кол-во",
  "First seen": "Впервые",
  "No error reports": "Отчётов об ошибках нет",
  "Could not load error reports": "Не удалось загрузить отчёты об ошибках",
  "Could not load the report": "Не удалось загрузить отчёт",
  "Report updated": "Отчёт обновлён",
  "Could not update the report": "Не удалось обновить отчёт",
  "Seen {n} times": "Встречалась {n} раз",
  "Mark resolved": "Отметить решённой",
  "Reopen": "Открыть снова",
};

const es = {
  "Error reports": "Informes de errores",
  "Server and browser errors grouped by cause. Resolve hides a report until the error happens again; Ignore keeps it quiet.": "Errores del servidor y del navegador agrupados por causa. Resuelto oculta un informe hasta que el error vuelva a ocurrir; Ignorar lo silencia.",
  "Unresolved": "Sin resolver",
  "Ignored": "Ignorados",
  "All": "Todos",
  "All sources": "Todas las fuentes",
  "Server": "Servidor",
  "Search by error text": "Buscar por texto del error",
  "Count": "Cantidad",
  "First seen": "Primera vez",
  "No error reports": "No hay informes de errores",
  "Could not load error reports": "No se pudieron cargar los informes de errores",
  "Could not load the report": "No se pudo cargar el informe",
  "Report updated": "Informe actualizado",
  "Could not update the report": "No se pudo actualizar el informe",
  "Seen {n} times": "Visto {n} veces",
  "Mark resolved": "Marcar como resuelto",
  "Reopen": "Reabrir",
};

const pt = {
  "Error reports": "Relatórios de erros",
  "Server and browser errors grouped by cause. Resolve hides a report until the error happens again; Ignore keeps it quiet.": "Erros do servidor e do navegador agrupados por causa. Resolvido oculta um relatório até o erro voltar a acontecer; Ignorar o silencia.",
  "Unresolved": "Não resolvidos",
  "Ignored": "Ignorados",
  "All": "Todos",
  "All sources": "Todas as fontes",
  "Server": "Servidor",
  "Search by error text": "Buscar pelo texto do erro",
  "Count": "Quantidade",
  "First seen": "Primeira vez",
  "No error reports": "Nenhum relatório de erro",
  "Could not load error reports": "Não foi possível carregar os relatórios de erros",
  "Could not load the report": "Não foi possível carregar o relatório",
  "Report updated": "Relatório atualizado",
  "Could not update the report": "Não foi possível atualizar o relatório",
  "Seen {n} times": "Visto {n} vezes",
  "Mark resolved": "Marcar como resolvido",
  "Reopen": "Reabrir",
};

const ERROR_REPORTS = { ru, es, pt };
export default ERROR_REPORTS;
